<template>
  <div>
    <div class="l-banner">
      <div class="l-banner-mask"></div>
      <div class="wrap">
        <div class="container-fluid l-banner-content">
          <b>{{ title }}</b>
          <em class="l-banner-line"></em>
          <p>
            秉持着坚持品质、责任、精新、执着的理念，致力成为您满意的合作伙伴，为客户提供完善的产品和服务。
          </p>
        </div>
      </div>
    </div>
    <div class="position">
      <div class="wrap">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-5 col-12 position-left">
              <i class="iconfont icon-fangzi"></i>
              <p>
                位置：<a href="/">首页</a>
                <span
                  style="cursor: pointer"
                  v-for="path in paths"
                  :key="path.url"
                >
                  &gt;
                  <a @click="goPath(path.url)">{{ path.label }}</a>
                </span>
                &gt;
                <a href="javascript:;">{{ title }}</a>
              </p>
            </div>
            <div class="col-lg-7 col-12 position-right">
              <a
                :href="option.path"
                v-for="(option, index) in optionRight"
                :key="index"
              >
                {{ option.label }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    optionRight: {
      type: Array,
      default: () => {
        return [
          // {
          //   label: "公司简介",
          //   path: "/about",
          // },
        ];
      },
    },
    title: {
      type: String,
      default: "",
    },
    paths: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    goPath(url) {
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.l-banner {
  position: relative;
  min-height: 280px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}

.l-banner-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(15, 23, 42, 0.18) 0%,
    rgba(15, 23, 42, 0.22) 50%,
    rgba(15, 23, 42, 0.38) 100%
  );
  pointer-events: none;
}

.l-banner-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
}

.l-banner b {
  font-size: 42px;
  font-weight: 500;
  letter-spacing: 0.28em;
  line-height: 1.2;
  text-indent: 0.28em;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

.l-banner-line {
  display: block;
  width: 40px;
  height: 2px;
  margin: 16px 0 18px;
  background: #ff8c00;
  font-style: normal;
}

.l-banner p {
  max-width: 640px;
  padding: 0;
  margin: 0;
  font-size: 14px;
  line-height: 1.8;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
}

.row {
  display: flex;
  justify-content: space-between;
  text-align: left;
  .iconfont {
    color: @primaryColor;
  }
}
.position-right {
  a {
    &:hover {
      background: #1f1bc0;
    }
  }
}

@media (max-width: 768px) {
  .l-banner {
    min-height: 200px;
  }
  .l-banner b {
    font-size: 28px;
    letter-spacing: 0.16em;
  }
  .l-banner-content {
    padding: 32px 16px;
  }
}
</style>
